export const plataformaEnum = [
    "CADSEI",
    "FORMS",
    "NOVO SIGPLANI CREDITO FINANCEIRO",    
    "Sigplani Módulo Inclusão Produtos",
    "Sigplani Módulo Inclusão Modelos",
    "NOVO SIGPLANI RDA",
    "SIGPPI",
    "FACTI",
    "SEI-MOVER"
];